import { FC } from 'react';
import MarketplaceFeatureContact from '../../components/MarketplaceFeatureContact/MarketplaceFeatureContact';
import { takerKnowledgeUrl } from '../../constants/marketplace';
import { localeStore } from '~/mobx/localesStore';

const UnavailableFeatureContent: FC<{ name: string }> = ({ name }): JSX.Element => {
  return (
    <div className="d-flex mt-6">
      <div className="w-60 mr-12">
        <p className="family-regular text-size-20 mb-3">{localeStore.t(`${name}_description`)}</p>
        <a href={takerKnowledgeUrl} target="_blank" rel="noopener noreferrer" className="color-mainblue text-size-20 family-regular w-fit-content">
          {localeStore.t('link_to_knowledge_base')}
        </a>
      </div>
      <MarketplaceFeatureContact />
    </div>
  );
};

export default UnavailableFeatureContent;
